import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  objectType: "", // According to the implemented entity
  referenceModule: "",
  moduleType: "",
  selectedAttachments: [], // Selected files
  selectedMentionsUsers: [], // Mentioned users id
  commentsLoader: false,
  filesList: [],
  objectSharedUid: "", // Specific object shared uid
  multiMetaShearedUid: [], // For multiple meta shared uids(forcaster discussion all Forecasts tab)
  isExpandCommentBox: false, // expand/collapse state of the comment box when adding a comment
  editingCommentId: "", // ID of the comment being edited
  postCommentTrackID: "",
  reactionTrackID: "",
  uploadFileTrackID: "",
  downloadFileTrackID: "",
  previewFileTrackID: "",
  isCommentLoading: false,
  deleteLoader: false,
  commentObjectID: "", // (Specific object shared uid when editing/deleting a comment or adding a file in All Forecasts tab)
  deleteArray: [], // Array to hold IDs of comments/files to be deleted
};

const genericCommentsAndFilesSlice = createSlice({
  name: "genericCommentsAndFiles",
  initialState: initialState,
  reducers: {
    setObjectType: (state, action) => {
      state.objectType = action.payload;
    },
    setReferenceModule: (state, action) => {
      state.referenceModule = action.payload;
    },
    setModuleType: (state, action) => {
      state.moduleType = action.payload;
    },
    setSelectedAttachments: (state, action) => {
      state.selectedAttachments = action.payload;
    },
    setSelectedMentionsUsers: (state, action) => {
      state.selectedMentionsUsers = action.payload;
    },
    setCommentsLoader: (state, action) => {
      state.commentsLoader = action.payload;
    },
    setFilesList: (state, action) => {
      state.filesList = action.payload;
    },
    setObjectSharedUid: (state, action) => {
      state.objectSharedUid = action.payload;
    },
    setMultiMetaSharedUid: (state, action) => {
      state.multiMetaShearedUid = action.payload;
    },
    setIsExpandCommentBox: (state, action) => {
      state.isExpandCommentBox = action.payload;
    },
    setEditingCommentId: (state, action) => {
      state.editingCommentId = action.payload;
    },
    setPostCommentTrackID: (state, action) => {
      state.postCommentTrackID = action.payload;
    },
    setReactionTrackID: (state, action) => {
      state.reactionTrackID = action.payload;
    },
    setUploadFileTrackID: (state, action) => {
      state.uploadFileTrackID = action.payload;
    },
    setDownloadFileTrackID: (state, action) => {
      state.downloadFileTrackID = action.payload;
    },
    setPreviewFileTrackID: (state, action) => {
      state.previewFileTrackID = action.payload;
    },
    setCommentObjectID: (state, action) => {
      state.commentObjectID = action.payload;
    },
    setIsCommentLoading: (state, action) => {
      state.isCommentLoading = action.payload;
    },
    setDeleteLoader: (state, action) => {
      state.deleteLoader = action.payload;
    },
    setDeleteArray: (state, action) => {
      state.deleteArray = action.payload;
    },

    //Reset only shared uids (for tab switching)(Forecaster discussion)
    resetSharedUids: (state) => {
      state.objectSharedUid = "";
      state.multiMetaShearedUid = [];
    },
    resetOfCommentsAndFiles: () => initialState, // reset everything
  },
});

export const {
  setObjectType,
  setReferenceModule,
  setModuleType,
  setSelectedAttachments,
  setSelectedMentionsUsers,
  setCommentsLoader,
  setFilesList,
  setObjectSharedUid,
  setMultiMetaSharedUid,
  setIsExpandCommentBox,
  setEditingCommentId,
  setPostCommentTrackID,
  setReactionTrackID,
  setUploadFileTrackID,
  setDownloadFileTrackID,
  setPreviewFileTrackID,
  setCommentObjectID,
  resetSharedUids,
  resetOfCommentsAndFiles,
  setIsCommentLoading,
  setDeleteLoader,
  setDeleteArray,
} = genericCommentsAndFilesSlice.actions;

export default genericCommentsAndFilesSlice.reducer;
